import {
  faDollarSign,
  faPercent,
  faShoppingCart,
  faArrowTrendUp,
  faArrowTrendDown,
  faMinus,
  faSearch,
  faFilter,
  faArrowLeft,
  faCreditCard,
  faTruck,
  faGift,
  faTag,
  faCircleExclamation,
  faRotateRight,
  faDownload,
  faEye,
  faCalendar,
  faMobileScreen,
  faDesktop,
  faBox,
  faTruckFast,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';

export const ICONS = {
  dollar: faDollarSign,
  percent: faPercent,
  shoppingCart: faShoppingCart,
  trendingUp: faArrowTrendUp,
  trendingDown: faArrowTrendDown,
  minus: faMinus,
  search: faSearch,
  filter: faFilter,
  arrowLeft: faArrowLeft,
  creditCard: faCreditCard,
  truck: faTruck,
  gift: faGift,
  tag: faTag,
  alertCircle: faCircleExclamation,
  refresh: faRotateRight,
  download: faDownload,
  eye: faEye,
  calendar: faCalendar,
  mobile: faMobileScreen,
  desktop: faDesktop,
  package: faBox,
  delivery: faTruckFast,
  info: faInfoCircle,
};

export const FEE_CATEGORY_ICONS: Record<string, any> = {
  delivery: faTruck,
  processing: faCreditCard,
  stripe: faCreditCard,
  tax: faPercent,
  tips: faGift,
  discounts: faTag,
};

export const FEE_CATEGORY_COLORS: Record<string, string> = {
  delivery: '#1890ff',
  processing: '#722ed1',
  stripe: '#ff4d4f',
  tax: '#fa8c16',
  tips: '#52c41a',
  discounts: '#ff4d4f',
};

export const PLATFORM_ICONS: Record<string, any> = {
  kiosk: faDesktop,
  mobile: faMobileScreen,
};

export const FULFILLMENT_ICONS: Record<string, any> = {
  pickup: faBox,
  delivery: faTruckFast,
};

export const TAB_KEYS = {
  PLATFORM: 'platform',
  FULFILLMENT: 'fulfillment',
  FEES: 'fees',
} as const;

export const CARD_COLORS = {
  blue: {
    light: '#e6f7ff',
    dark: '#001529',
    border: '#91d5ff',
  },
  green: {
    light: '#f6ffed',
    dark: '#162312',
    border: '#b7eb8f',
  },
  orange: {
    light: '#fff7e6',
    dark: '#2b1d11',
    border: '#ffd591',
  },
  purple: {
    light: '#f9f0ff',
    dark: '#1a1325',
    border: '#d3adf7',
  },
} as const;

export const DEFAULT_DATE_RANGE = {
  days: 1,
} as const;

export const CSV_FILENAME_FORMAT = 'YYYY-MM-DD';

export const FEE_CATEGORY_COLUMNS = [
  {
    title: 'Category',
    dataIndex: 'category',
    key: 'category',
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    align: 'right' as const,
  },
  {
    title: 'Count',
    dataIndex: 'count',
    key: 'count',
    align: 'right' as const,
  },
  {
    title: 'Percentage',
    dataIndex: 'percentage',
    key: 'percentage',
    align: 'right' as const,
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
  },
] as const;

export const ERROR_MESSAGES = {
  NO_MERCHANT_DATA: 'Merchant data is loading. Please wait...',
  NO_STORE: 'Store ID is missing. Please select a store.',
  NO_STORES_FOUND: 'No stores found for this merchant. Please contact support.',
  NO_DATA_RECEIVED: 'No data received from server',
  FETCH_FAILED: 'Failed to fetch earnings data',
  EXPORT_FAILED: 'Failed to export earnings data',
} as const;

export const SUCCESS_MESSAGES = {
  EXPORT_SUCCESS: 'Earnings data exported to CSV',
} as const;

export const LOADING_MESSAGES = {
  INITIAL: 'Loading merchant data and stores...',
  EARNINGS: 'Loading earnings data...',
} as const;

export const NO_DATA_REASONS = [
  'No transactions occurred in this period',
  'The selected store has no activity',
  'Data is still being processed',
] as const;
